import { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Box } from '@/components/ui/box'
import { Flex } from '@/components/ui/flex'
import { Slider } from '@/components/ui/slider'
import { Text } from '@/components/ui/typography'
import useColorModeValue from '@/hooks/useColorModeValue'
import { TProcessingStrategy } from '@/types/gigiChat/ConversationSettings'

const TemperatureSlider = ({
    min = 0,
    max = 1,
    step = 0.1,
    value,
    onChange,
    hasOpacity,
}: {
    min?: number
    max?: number
    step?: number
    value: number
    strategy?: TProcessingStrategy
    onChange: (value: number) => void
    hasOpacity: boolean
}) => {
    const { t } = useTranslation()
    const [n, setN] = useState(value)

    useEffect(() => {
        setN(value)
    }, [value])

    const afterBackground = useColorModeValue('rgba(255, 255, 255, 0.7)', 'rgba(13, 13, 13, 0.7)')

    const overlay = hasOpacity
        ? {
              _after: {
                  content: '""',
                  position: 'absolute',
                  width: '100%',
                  height: '100%',
                  bottom: '0',
                  left: '0',
                  backgroundColor: afterBackground,
                  zIndex: '999',
              },
          }
        : {}

    const sliderValue = useMemo(() => {
        return [n]
    }, [n])

    return (
        <Box position="relative" {...overlay} data-testid="chat-settings-temperature-slider">
            <Flex gap="10px" px="20px">
                <Text fontSize="14px">{t('chat.settings.writing.slider.predictable')}</Text>
                <Slider
                    value={sliderValue}
                    onValueChange={(e) => setN(e.value[0])}
                    onValueChangeEnd={(e) => onChange(e.value[0])}
                    min={min}
                    max={max}
                    step={step}
                    aria-label="temperature-slider"
                    variant="gigi"
                    flex="1"
                />
                <Text fontSize="14px">{t('chat.settings.writing.slider.creative')}</Text>
            </Flex>
            <Text color="rgba(84, 79, 64, 0.7)" pt="20px" pb="8px" fontSize="12px" letterSpacing="0.5px" px="20px">
                {t('chat.settings.writing.slider.description')}
            </Text>
        </Box>
    )
}

export default TemperatureSlider
